import React from "react";
import { colors } from "../../../../utils/theme";
import styled from "styled-components";

const Conatiner = styled.div`
  margin: 3rem 0;
  padding-bottom: 1rem;
  .paginator {
    padding: 1rem;
    display: flex;
    background-color: ${colors.gris};
    margin-bottom: 2rem;
    justify-content: center;
  }

  .title {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
    display: block;

    @media (max-width: 600px) {
      font-size: 1.3rem;
      text-align: center;
    }
  }

  p {
    width: 90%;
    margin: 0 auto;
    text-align: left;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: ${colors.fifth};
    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
    @media (max-width: 425px) {
      font-size: 1rem;
    }
  }
  span {
    color: ${colors.third};
  }
  .agendar {
    font-weight: bold;
  }
`;

export const ReminderComponentsContinuidad = () => {
  return (
    <Conatiner>
      <div className="paginator">
        <span className="title">RECORDATORIO</span>
      </div>
      <p>
        Recuerde que su cita es presencial, por lo que debe presentarse con 15 minutos de anticipación y debe traer:<br /><br />
        <span>- </span>Orden medica.<br />
        <span>- </span>1 toalla tamaño cuerpo.<br />
        <span>- </span>Ropa adecuada para el tipo de terapia a realizar:<br />
        <span>&emsp;&emsp;&emsp;&#x2713; </span>Miembro inferior: &ensp;&ensp;Pantaloneta.<br />
        <span>&emsp;&emsp;&emsp;&#x2713; </span>Miembro superior: &ensp;Camisilla o top.<br />
        <span>&emsp;&emsp;&emsp;&#x2713; </span>Gimnasio: &emsp;&emsp;&emsp;&emsp;&ensp;Ropa deportiva y tenis.<br />
        <span>&emsp;&emsp;&emsp;&#x2713; </span>Hidroterapia: &emsp;&ensp;&ensp;&ensp;&nbsp;&nbsp;Pantaloneta o vestido de baño.<br />
      </p>
      <p>
        Si necesita cancelar o reprogramar, hágalo en nuestra página web haciendo clic en <span className="agendar">"AGENDAR CITA"</span> en la sección
        <span className="agendar">"CANCELACIÓN DE CITA"</span>, reagende para evitar penalizaciones. <br /><br />
        Contáctenos al WhatsApp 3217838252 si necesita ayuda. <br />
        ¡Gracias por confiar en nosotros y esperamos verlo pronto en Mi Físico!
      </p>
    </Conatiner>
  );
};
